import { render } from "./DocumentDownload.vue?vue&type=template&id=ea3ea4d8"
import script from "./DocumentDownload.vue?vue&type=script&lang=js"
export * from "./DocumentDownload.vue?vue&type=script&lang=js"

import "./DocumentDownload.vue?vue&type=style&index=0&id=ea3ea4d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__